
export enum UserMutationTypes {
    SET_USER = 'SET_USER',
    SET_USER_CONSENT = 'SET_USER_CONSENT',
    SET_USER_SOCIAL_REFID = 'SET_USER_SOCIAL_REFID',

}
